import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getCameras } from './api';
import type { GetCamerasResponse } from './types';

export const CamerasControlGate = createGate<void>();

const fxGetCameras = createEffect<void, GetCamerasResponse, Error>().use(getCameras);

export const camerasQuery = createQuery({
  name: 'Cameras',
  effect: fxGetCameras,
  mapData: ({ result }) =>
    Array.isArray(result?.cameras)
      ? result.cameras.map((item) => ({
          id: item?.camera?.id,
          label: item?.camera?.title ?? '',
        }))
      : [],
});

sample({
  clock: CamerasControlGate.open,
  source: CamerasControlGate.status,
  filter: (status) => Boolean(status),
  target: camerasQuery.start,
});
